import { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false, error: null }
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error }
	}

	componentDidCatch(error, info) {
		const { onError } = this.props
		if (typeof onError === 'function') {
			onError(error, info)
		}
	}

	render() {
		const { hasError, error } = this.state
		const { children, fallback } = this.props

		if (hasError) {
			return fallback(error)
		}

		return children
	}
}

export default ErrorBoundary

ErrorBoundary.propTypes = {
	fallback: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
	onError: PropTypes.func,
	children: PropTypes.node
}

ErrorBoundary.defaultProps = {
	onError: null,
	children: null
}
